const VERIFY_ONE_TIME_CODE = {
  ACCESS_DENIED: 'access_denied',
  INVALID_REQUEST: 'bad.verification_code',
  INVALID_USER_PASSWORD: 'invalid_user_password',
};

export { VERIFY_ONE_TIME_CODE };
